import type { CssGeneratorContext } from '../css-generator.model';

export const styles = ({ dt }: CssGeneratorContext) => `.footer {
	background: ${dt('named.footer.background')};
	border-top: 1px solid ${dt('named.footer.border.color')};

	& .footer-inner {
		display: flex;
		align-items: center;
		justify-content: space-between;
		height: 64px;
		padding-inline: 1.5rem;
		font-size: 0.875rem;
		color: ${dt('text.muted.color')};

		& a {
			color: ${dt('primary.color')};
			text-decoration: none;

			&:hover {
				text-decoration: underline;
			}
		}
	}
}`;
